<template>
  <div class="tolerance-page">
    <div class="container">
      <h1 class="page-title">Die Casting Capabilities</h1>

      <div class="tolerance-table-wrapper">
        <table class="tolerance-table">
          <thead>
            <tr>
              <th></th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tolerance</td>
              <td>High-precision die casted parts need secondary machining to meet tolerance requirements, achieving accuracy up to ±0.01mm</td>
            </tr>
            <tr>
              <td>Minimum Wall Thickness</td>
              <td>Aluminum alloy recommended 1.5mm, zinc alloy can go down to 0.8mm</td>
            </tr>
            <tr>
              <td>Wall Thickness Ratio</td>
              <td>Keep within 1:3 ratio to avoid uneven filling</td>
            </tr>
            <tr>
              <td>Hole Diameter</td>
              <td>Due to high temperatures during aluminum die casting mold processing, round holes smaller than 3mm diameter require secondary drilling. Product threaded holes and external threads are formed through secondary machining.</td>
            </tr>
            <tr>
              <td>Draft Angle</td>
              <td>Minimum 0.5° to avoid demolding difficulties</td>
            </tr>
            <tr>
              <td>Maximum Die Life (Number of Cycles)</td>
              <td>Zinc: 1,000,000 Magnesium, Aluminum: 100,000</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="button-wrapper">
        <button class="getQuote-btn" @click="$router.push('/quote')">Get Instant Quote</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Die_Capabilities'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.tolerance-page {
  /* ✨ 利用 clamp 实现动态内边距：最小 30px，按 5vw 缩放，最大 60px */
  padding: clamp(30px, 5vw, 60px) 20px;
  background-color: #ffffff;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* 标题样式 */
.page-title {
  /* ✨ 标题动态字号：手机端最小 26px，大屏最大 36px */
  font-size: clamp(26px, 4vw, 36px);
  color: #333333;
  margin: 0 0 clamp(20px, 4vw, 30px);
  font-weight: 600;
}

.tolerance-table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto; /* ✨ 允许横向滑动 */
  -webkit-overflow-scrolling: touch; /* ✨ 让 iOS 设备上滑动更顺滑 */
}

.tolerance-table {
  width: 100%;
  min-width: 600px; /* ✨ 核心：限制表格最小宽度，防止在极小手机屏幕上文字被挤压变形 */
  border-collapse: collapse;
  background-color: #ffffff;
  table-layout: fixed;
}

.tolerance-table thead tr {
  background-color: #f0f4f5;
}

.tolerance-table th,
.tolerance-table td {
  padding: 20px 15px;
  text-align: center;
  border: 1px solid #e5e7eb;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
}

.tolerance-table th {
  font-weight: 600;
}

.tolerance-table td:first-child,
.tolerance-table th:first-child {
  font-weight: 600; /* ✨ 左侧标题稍微加粗一点更好看 */
  width: 25%; /* ✨ 桌面端比例调整为 25% : 75% 更协调 */
}

.tolerance-table td:last-child {
  width: 75%;
  text-align: center; /* ✨ PC端居中对齐 */
}

/* 按钮容器 */
.button-wrapper {
  display: flex;
  justify-content: center;
}

.getQuote-btn {
  background-color: #16bc9c;
  color: #ffffff;
  border: none;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.getQuote-btn:hover {
  background-color: #13a88b;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .tolerance-table th,
  .tolerance-table td {
    padding: 15px 10px;
    font-size: 14px;
  }

  /* ✨ 在移动端重新分配列宽，给左侧更多空间 */
  .tolerance-table td:first-child,
  .tolerance-table th:first-child {
    width: 35%;
  }

  .tolerance-table td:last-child {
    width: 65%;
    text-align: left; /* ✨ 移动端滑动时左对齐，提升阅读体验 */
  }
}
</style>